import React, { Component } from 'react';
import { Popover, Input, Modal, Icon, Button, Checkbox, Radio, Transfer, Select } from 'antd';
import { Format } from '../../../helpers/formatDate';
import Row from '../../basic/row';
import Col from '../../basic/col';
import * as eChartCommon from '../eChartCommon';
import * as eChartDemoData from '../eChartDemoData';
import * as eChartProxy from '../eChartProxy';
import SvgIcon from 'SvgIcon';

export default class eChartPanelSetNotice extends React.Component {
  constructor(props) {
    super(props);
    eChartCommon.LogChartInfo("eChartPanelSetNotice constructor ", "", 900)
    this.bVisible = !!props.bVisible;
    this.state = { panelType: props.panelType || 1 };
    if (this.bVisible) {
      this.colEle = props.colEle;
      let config = props.colEle.componentConfig.noticeConfig || {};

      this.initState(true, config, props.panelType);
    }
  }
  initState(bFirst, noticeConfig, panelType) {
    let self = this;
    noticeConfig = noticeConfig || {};
    self.state = {
      panelType: self.state.panelType || panelType || 1,
      // chartKey: noticeConfig.chartKey,
      title: noticeConfig.title || "公告",
      fontSize: noticeConfig.fontSize || 12,
      num: noticeConfig.num || 5,
      fontFamily: 'STKaiti',// STSong = 华文宋体 // LiSu = 隶书 // YouYuan = 幼圆 // STXihei = 华文细黑 // STKaiti = 华文楷体 // STZhongsong = 华文中宋 // STFangsong = 华文仿宋 // FZShuTi = 方正舒体 // FZYaoti = 方正姚体 // STCaiyun = 华文彩云 // STHupo = 华文琥珀 // STLiti = 华文隶书 // STXingkai = 华文行楷 // STXinwei = 华文新魏
    };
  }
  shouldComponentUpdate(nextProps, nextState) {
    let bFlag;
    if (this.state.panelType == 3) {
      if (_.isEqual(nextState, this.state) == false) {
        bFlag = true;
      } else {
        bFlag = false;
      }
    } else {
      bFlag = true;
    }
    eChartCommon.LogChartInfo("eChartPanelSetNotice shouldComponentUpdate return ", bFlag, 900);
    return bFlag;
  }
  componentWillReceiveProps(nextProps) {
    eChartCommon.LogChartInfo("eChartPanelSetNotice componentWillReceiveProps ", "", 900)
    if (this.state.panelType == 3) {
      let preVisible = this.bVisible;
      this.bVisible = !!nextProps.bVisible;
      if (preVisible == true && this.bVisible == false) {
        this.forceUpdate();
      }
      else if (this.bVisible && (_.isEmpty(this.props.colEle) || _.isEqual(nextProps.colEle.noticeConfig, this.props.colEle.noticeConfig) == false)) {
        this.colEle = nextProps.colEle;
        this.initState(false, nextProps.colEle.noticeConfig, nextProps.panelType);
        this.forceUpdate();
      }
    }
  }
  render() {
    eChartCommon.LogChartInfo("eChartPanelSetNotice render ", "", 900)
    let self = this;
    if (!self.bVisible) {
      return <div className="eChartPanelDesign_SetNotice3_NoData" />;
    }
    let content = self.getCardContent();
    if (this.state.panelType == 3) {
      return <div
        className="eChartPanelDesign_SetNotice3"
        key={"SetNoticeKey_" + self.colEle.colKey}
      >
        {content}
        <div className="eChartPanelSplit_bottom3">
          <Button type={"primary"} onClick={() => self.doFunc(true)}>确定</Button>
          <Button type={"default"} onClick={() => self.doFunc(false)}>取消</Button>
        </div>
      </div>;
    }
    else {
      return <Modal
        className="eChartPanelDesign_SetNotice"
        title="添加公告"
        onOk={(e) => self.doFunc(true)}
        onCancel={(e) => self.doFunc(false)}
        visible={true}
      >
        {content}
      </Modal>;
    }
  }


  getCardContent() {
    let self = this;
    let { panelType } = this.state;
    let content = <div className="hz">
      <Row className="width-less-pl">
        <Col className="eChartPanelSetNotice_1" >显示条数</Col>
        <Col>
          <Input defaultValue={self.state.num} onChange={(e) => this.setState({ "num": e.target.value })} />
        </Col>
      </Row>
      <Row className="width-less-pl">
        <Col className="eChartPanelSetNotice_2" >标题内容</Col>
        <Col>
          <Input defaultValue={self.state.title} onChange={(e) => this.setState({ "title": e.target.value })} />
        </Col>
      </Row>
      <Row className="width-less-pl">
        <Col className="eChartPanelSetNotice_3" > 字体大小</Col>
        <Col>
          <Input defaultValue={self.state.fontSize} onChange={(e) => this.setState({ "fontSize": e.target.value })} />
        </Col>
      </Row>

    </div>;
    return content;
  }


  checkInteger(fieldValue, bCanZero, bCanSmallThanZero, bCanNumPoint) {
    if (fieldValue.toString().trim() == "") {
      return false;
    } else if (isNaN(fieldValue) == true) {
      return false;
    } else if (bCanZero == false && Number(fieldValue) == 0) {
      return false;
    } else if (bCanSmallThanZero == false && Number(fieldValue) < 0) {
      return false;
    } else if (bCanNumPoint == false && fieldValue.toString().indexOf(".") >= 0) {
      return false;
    }
    return true;
  }
  doFunc(bOK) {
    if (bOK) {
      let info = {};
      // info.chartKey = this.state.chartKey || eChartCommon.getNewChartKey();
      info.title = this.state.title;
      info.fontSize = this.state.fontSize;
      info.num = this.state.num;
      // info.innerFName = "看板配置信息-模块配置-公告";

      if (this.checkInteger(info.fontSize, false, false, false) == false) {
        cb.utils.alert('标题字体大小设置不正确', 'error');
      }
      else if (this.checkInteger(info.num, false, false, false) == false) {
        cb.utils.alert('显示条数设置不正确', 'error');
      }
      else if (_.isEmpty(info.title)) {
        cb.utils.alert('标题内容不可为空', 'error')
      }
      else {
        this.props.doFunc(bOK, info);
      }
    }
    else {
      this.props.doFunc(bOK);
    }
  }

  componentDidMount() {

  }
  componentWillUnmount() {

  }


}





// WEBPACK FOOTER //
// ./src/yxyweb/common/components/echart/panel/eChartPanelSetNotice.jsx